
<template>
  <div class="pba-background">
    <swiper
      :loop="website_data.slideshow.length > 1"
      :autoplay="website_data.slideshow.length > 1 && { delay: 5000, disableOnInteraction: false }"
      :allow-touch-move="website_data.slideshow.length > 1"
      @swiper="$set(swipers, 'slideshow', $event)"
    >
      <swiper-slide
        v-for="({ slideshow_title, slideshow_desc, slideshow_image }, i) in website_data.slideshow" :key="i"
      >
        <v-img
          :src="slideshow_image"
          dark class="pba-slideshow d-flex"
        >
          <v-container class="d-flex flex-column fill-height align-start justify-center pb-lg-16 pb-8">
            <v-card
              flat color="transparent"
              class="pba-headline text-wrap pba-text-shadow"
              v-html="slideshow_title"
            />
            <v-card
              flat color="transparent"
              class="pba-headline-sub text-wrap pba-text-shadow"
              v-html="slideshow_desc"
            />
          </v-container>
        </v-img>
      </swiper-slide>
    </swiper>

    <v-container v-if="website_data.profile.hotel_simplebooking" class="pa-0">
      <v-card
        id="form-book"
        tile light color="pba-primary" :elevation="isMobile ? 0 : 24"
        class="pba-form-book d-flex flex-wrap align-center"
        style="z-index: 1"
      >
        <v-form ref="form" v-model="bookingValid">
          <v-row no-gutters>
            <v-col cols="12" lg="6" class="pos-relative">
              <v-menu
                v-model="booking.periodModel"
                attach offset-y
                :close-on-content-click="false"
              >
                <template #activator="{ on, attrs }">
                  <v-row no-gutters class="d-flex flex-nowrap">
                    <v-col class="pba-form-book-input">
                      <div class="pba-form-book-input-label white--text">
                        Check In Date
                      </div>
                      <v-text-field
                        id="formBook-checkIn"
                        :value="formatDate([...booking.periodRange].sort()[0])"
                        solo flat readonly
                        class="rounded-0"
                        hide-details
                        single-line
                        label="check in date"
                        :rules="rules.required"
                        v-bind="attrs"
                        v-on="on"
                      />
                    </v-col>
                    <v-col class="pba-form-book-input">
                      <div class="pba-form-book-input-label white--text">
                        Check Out Date
                      </div>
                      <v-text-field
                        id="formBook-checkOut"
                        :value="formatDate([...booking.periodRange].sort()[1])"
                        solo flat readonly
                        class="rounded-0"
                        hide-details
                        single-line
                        label="check out date"
                        :rules="rules.required"
                        v-bind="attrs"
                        v-on="on"
                      />
                    </v-col>
                  </v-row>
                </template>
                <v-date-picker
                  v-model="booking.periodRange"
                  range reactive no-title full-width
                  color="pba-primary"
                />
              </v-menu>
            </v-col>
            <v-col cols="12" lg="6">
              <v-row no-gutters class="d-flex flex-nowrap">
                <v-col class="pba-form-book-input">
                  <div class="pba-form-book-input-label white--text">
                    Guests
                  </div>
                  <v-text-field
                    id="formBook-guests"
                    v-model="booking.guests"
                    solo flat hide-details hide-spin-buttons single-line
                    class="rounded-0"
                    type="number"
                    label="guests"
                    :rules="rules.required"
                  >
                    <v-icon
                      slot="append" color="pba-primary" class="cursor-pointer"
                      @click="booking.guests = parseInt(booking.guests || 0) + 1"
                    >
                      mdi-plus
                    </v-icon>
                    <v-icon
                      slot="prepend-inner" color="pba-primary" class="cursor-pointer"
                      :disabled="booking.guests < 1"
                      @click="booking.guests = parseInt(booking.guests || 0) - 1"
                    >
                      mdi-minus
                    </v-icon>
                  </v-text-field>
                </v-col>
                <v-col class="pba-form-book-input d-flex align-end justify-end">
                  <v-btn
                    id="formBook-submit"
                    elevation="0" tile color="pba-secondary"
                    class="pba-btn-book flex-grow-1 flex-lg-grow-0 text-uppercase pba-primary--text"
                    :href="bookingLink"
                    target="_blank" rel="noopener nofollow"
                    @click="bookingLink ? gtagClickEvent('Form', label_data.BOOK_NOW) : $refs.form.validate()"
                    v-html="label_data.BOOK_NOW"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
    <v-container v-else class="py-16" />

    <v-container id="section-about" class="pba-about">
      <v-row no-gutters class="pba-section flex-wrap-reverse justify-space-between align-center">
        <v-col cols="12" lg="6" class="pba-about-info pe-lg-4 d-flex flex-column align-start">
          <!-- Removed by request -->
          <!-- <span
            v-if="label_data.MENU_ABOUTUS"
            class="pba-text-section-name pba-secondary text-uppercase"
            v-html="label_data.MENU_ABOUTUS"
          /> -->
          <div
            class="pba-text-section-headline pba-primary--text mb-4 mb-lg-8"
            v-html="website_data.profile.headline_about"
          />
          <div
            class="pba-text-section-body overflow-auto pe-2"
            v-html="website_data.profile.text_about"
          />
        </v-col>

        <v-col cols="12" lg="6" class="mb-7 mb-lg-0">
          <v-row no-gutters class="ma-n2 fill-height d-flex flex-row">
            <v-col
              v-for="({ gallery_image }, i) in website_data.thumbnail_about" :key="i"
              :cols="i + 1 === website_data.thumbnail_about.length && !(i % 2) ? 12 : 6"
              class="pa-2"
            >
              <v-img
                class="cursor-pointer fill-height"
                :class="
                  website_data.thumbnail_about.length <= 2
                    ? 'pba-about-img-tall'
                    : i + 1 === website_data.thumbnail_about.length && !(i % 2)
                      ? 'pba-about-img-large'
                      : 'pba-about-img'
                "
                :src="gallery_image + '?d=568x461&location=center'"
                @click="viewDialogImage('about', i)"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-container id="section-rooms" class="pba-section">
      <span
        v-if="label_data.MENU_ROOMS"
        class="pba-text-section-name pba-secondary text-uppercase"
        v-html="label_data.MENU_ROOMS"
      />

      <div
        class="pba-text-section-headline pba-primary--text mb-4 mb-lg-8"
        v-html="website_data.profile.headline_rooms"
      />

      <v-row no-gutters class="d-flex flex-column flex-lg-row align-stretch ma-n2">
        <v-col cols="12" lg="7" class="pa-2 pos-relative">
          <div v-if="swipers.roomsImages && roomsSwipers[swipers.roomsImages.realIndex].slides.length > 1" class="pa-2 pba-swiper-buttons-inside d-none d-lg-flex justify-end align-end">
            <v-btn
              style="z-index: 2"
              color="pba-secondary" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
              :disabled="roomsSwipers[swipers.roomsImages.realIndex].isBeginning"
              @click="roomsSwipers[swipers.roomsImages.realIndex].slidePrev()"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn
              style="z-index: 2"
              color="white" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
              :disabled="roomsSwipers[swipers.roomsImages.realIndex].isEnd"
              @click="roomsSwipers[swipers.roomsImages.realIndex].slideNext()"
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
          <swiper
            :space-between="16"
            :allow-touch-move="false"
            @swiper="$set(swipers, 'roomsImages', $event)"
            @slideChange="
              gtagClickEvent(
                'Rooms',
                `Gallery '${website_data.rooms[swipers.roomsImages.realIndex].room_title}' Swipe`
              )
            "
          >
            <swiper-slide v-for="({ room_id, room_image, room_title }, i) in website_data.rooms" :key="i">
              <swiper
                nested pagination
                :allow-touch-move="room_image.length > 1"
                @swiper="$set(roomsSwipers, i, $event)"
              >
                <swiper-slide v-for="({ image_url }, j) in room_image" :key="j">
                  <v-img
                    class="pba-rooms-img cursor-pointer"
                    :src="image_url + '?d=656x384&location=center'"
                    @click="
                      viewDialogImage(room_id, j)
                      gtagViewEvent(`Rooms Gallery '${room_title}'`)
                    "
                  >
                    <template #placeholder><progress-circular-primary /></template>
                  </v-img>
                </swiper-slide>
              </swiper>
            </swiper-slide>
          </swiper>
        </v-col>

        <v-col cols="12" lg="5" class="pa-2 pos-relative">
          <div
            v-if="swipers.roomsInfos && swipers.roomsInfos.slides.length > 1"
            class="pa-2 pba-swiper-buttons-inside justify-end"
          >
            <v-btn
              style="z-index: 2"
              color="pba-secondary" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
              :disabled="swipers.roomsInfos.isBeginning"
              @click="
                swipers.roomsImages.slidePrev()
                swipers.roomsInfos.slidePrev()
                roomsSwipers[swipers.roomsImages.realIndex].slideTo(0)
              "
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn
              style="z-index: 2"
              color="white" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
              :disabled="swipers.roomsInfos.isEnd"
              @click="
                swipers.roomsImages.slideNext()
                swipers.roomsInfos.slideNext()
                roomsSwipers[swipers.roomsImages.realIndex].slideTo(0)
              "
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
          <swiper
            :space-between="16"
            :allow-touch-move="false"
            class="d-flex flex-column fill-height pba-rooms-info"
            @swiper="$set(swipers, 'roomsInfos', $event)"
            @slideChange="gtagClickEvent('Rooms', 'Swipe Type')"
          >
            <swiper-slide
              v-for="({ room_id, room_title, room_desc, room_rate }, i) in website_data.rooms" :key="i"
              class="d-flex flex-column"
            >
              <div class="pba-rooms-info-name pba-surface pba-text-section-headline-sub pba-primary--text text-uppercase d-flex align-center px-2" v-text="room_title" />

              <div v-if="(roomrate_data[room_id] && roomrate_data[room_id].rate) || room_rate" class="d-lg-none mt-2 px-2">
                <div class="pba-text-section-body">
                  Starting from:
                </div>
                <div class="pba-rooms-info-price">
                  {{ website_data.profile.hotel_currency }} {{ ((roomrate_data[room_id] && roomrate_data[room_id].rate) || room_rate).toLocaleString('en-us') }} NET
                </div>
              </div>

              <div
                class="my-5 pba-text-section-body pba-rooms-info-description px-2 px-lg-0 overflow-auto"
                v-html="room_desc"
              />

              <v-spacer />

              <div v-if="(roomrate_data[room_id] && roomrate_data[room_id].rate) || room_rate" class="align-center d-none d-lg-flex">
                <div>
                  <div class="pba-text-section-body">
                    Starting from:
                  </div>
                  <div class="pba-rooms-info-price">
                    {{ website_data.profile.hotel_currency }} {{ ((roomrate_data[room_id] && roomrate_data[room_id].rate) || room_rate).toLocaleString('en-us') }} NET
                  </div>
                </div>
                <v-spacer />
                <v-btn
                  v-if="website_data.profile.hotel_simplebooking"
                  elevation="0" tile color="pba-primary"
                  class="pba-btn-book white--text text-uppercase"
                  :href="toQueryUrl(website_data.profile.hotel_simplebooking, utm_data)"
                  target="_blank" rel="noopener nofollow"
                  @click="gtagClickEvent('Rooms', `'${room_title}' Book Now`)"
                  v-html="label_data.BOOK_NOW"
                />
              </div>

              <div class="d-lg-none px-2">
                <v-btn
                  v-if="website_data.profile.hotel_simplebooking"
                  elevation="0" tile color="pba-primary"
                  class="pba-btn-book white--text text-uppercase" style="width: 100%"
                  :href="toQueryUrl(website_data.profile.hotel_simplebooking, utm_data)"
                  target="_blank" rel="noopener nofollow"
                  @click="gtagClickEvent('Rooms', `'${room_title}' Book Now`)"
                  v-html="label_data.BOOK_NOW"
                />
              </div>
            </swiper-slide>
          </swiper>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-if="website_data.meeting && website_data.meeting.length" id="section-meetings" class="pba-section">
      <div class="d-flex mb-4 mb-lg-8 align-end">
        <div>
          <span
            v-if="label_data.MENU_MEETINGS"
            class="pba-text-section-name pba-secondary text-uppercase"
            v-html="label_data.MENU_MEETINGS"
          />
          <div
            class="pba-text-section-headline pba-primary--text"
            v-html="website_data.profile.headline_meeting"
          />
        </div>
        <v-spacer />
        <div v-if="swipers.meetings" class="pba-swiper-buttons">
          <v-btn
            color="pba-secondary" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
            :disabled="swipers.meetings.isBeginning"
            @click="swipers.meetings.slidePrev()"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            color="white" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
            :disabled="swipers.meetings.isEnd"
            @click="swipers.meetings.slideNext()"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="pos-relative">
        <swiper
          :space-between="16"
          :allow-touch-move="website_data.meeting.length > 1"
          @swiper="$set(swipers, 'meetings', $event)"
        >
          <swiper-slide
            v-for="({ meeting_title, meeting_desc, meeting_image }, i) in website_data.meeting" :key="i"
            style="height: auto;"
            class="d-flex flex-column"
          >
            <v-img :src="meeting_image" class="pba-meetings-img">
              <template #placeholder><progress-circular-primary /></template>
            </v-img>
            <div class="d-flex flex-column align-center pba-facilities-info pba-surface flex-grow-1">
              <div
                class="pba-text-card-headline mb-4 pba-primary--text"
                v-html="meeting_title"
              />
              <div
                class="pba-text-card-body text-center"
                v-html="meeting_desc"
              />
            </div>
          </swiper-slide>
        </swiper>
        <div v-if="swipers.meetings" class="pba-swiper-buttons-mobile pba-swiper-buttons-mobile-meetings align-center justify-space-between">
          <v-btn
            tile color="pba-secondary" elevation="0"
            style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
            :disabled="swipers.meetings.isBeginning"
            @click="swipers.meetings.slidePrev()"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            tile color="white" elevation="0"
            style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
            :disabled="swipers.meetings.isEnd"
            @click="swipers.meetings.slideNext()"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-container>

    <v-container v-if="website_data.facility && website_data.facility.length" id="section-facilities" class="pba-section">
      <div class="d-flex mb-4 mb-lg-8 align-end">
        <div>
          <span
            v-if="label_data.MENU_FACILITIES"
            class="pba-text-section-name pba-secondary text-uppercase"
            v-html="label_data.MENU_FACILITIES"
          />
          <div
            class="pba-text-section-headline pba-primary--text"
            v-html="website_data.profile.headline_facility"
          />
        </div>
        <v-spacer />
        <div v-if="swipers.facilities && website_data.facility.length > 3" class="pba-swiper-buttons">
          <v-btn
            color="pba-secondary" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
            :disabled="swipers.facilities.isBeginning"
            @click="swipers.facilities.slidePrev()"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            color="white" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
            :disabled="swipers.facilities.isEnd"
            @click="swipers.facilities.slideNext()"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="pos-relative">
        <swiper
          :space-between="16"
          :breakpoints="{ 1264: { slidesPerView: 3 } }"
          :allow-touch-move="website_data.facility.length > (isMobile ? 1 : 3)"
          @swiper="$set(swipers, 'facilities', $event)"
        >
          <swiper-slide
            v-for="({ facility_title, facility_desc, facility_image }, i) in website_data.facility" :key="i"
            style="height: auto;"
            class="d-flex flex-column"
          >
            <v-img :src="facility_image + '?d=368x212&location=center'" class="pba-facilities-img">
              <template #placeholder><progress-circular-primary /></template>
            </v-img>
            <div class="d-flex flex-column flex-grow-1 align-center pba-facilities-info pba-surface">
              <div
                class="pba-text-card-headline mb-4 pba-primary--text"
                v-html="facility_title"
              />
              <div
                class="pba-text-card-body text-center"
                v-html="facility_desc"
              />
            </div>
          </swiper-slide>
        </swiper>
        <div v-if="swipers.facilities && website_data.facility.length > 1" class="pba-swiper-buttons-mobile pba-swiper-buttons-mobile-facilities align-center justify-space-between">
          <v-btn
            tile color="pba-secondary" elevation="0"
            style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
            :disabled="swipers.facilities.isBeginning"
            @click="swipers.facilities.slidePrev()"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            tile color="white" elevation="0"
            style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
            :disabled="swipers.facilities.isEnd"
            @click="swipers.facilities.slideNext()"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-container>

    <!-- Offers Section -->
    <v-container v-if="website_data.offers && website_data.offers.length" id="section-offers" class="pba-section">
      <div class="d-flex mb-4 mb-lg-8 align-end">
        <div>
          <span
            v-if="label_data.MENU_OFFERS"
            class="pba-text-section-name pba-secondary text-uppercase"
            v-html="label_data.MENU_OFFERS"
          />
          <div
            class="pba-text-section-headline pba-primary--text"
            v-html="website_data.profile.headline_offers"
          />
        </div>
        <v-spacer />
        <div v-if="swipers.offers && website_data.offers.length > 3" class="pba-swiper-buttons">
          <v-btn
            color="pba-secondary" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
            :disabled="swipers.offers.isBeginning"
            @click="swipers.offers.slidePrev()"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            color="white" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
            :disabled="swipers.offers.isEnd"
            @click="swipers.offers.slideNext()"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="pos-relative">
        <swiper
          :space-between="48"
          :breakpoints="{ 1264: { slidesPerView: 3 } }"
          :allow-touch-move="website_data.offers.length > (isMobile ? 1 : 3)"
          @swiper="$set(swipers, 'offers', $event)"
          @slideChange="gtagClickEvent('Offers', 'Swipe')"
        >
          <swiper-slide
            v-for="({
              offers_title, offers_preview, offers_image, offers_link, promo_code
            }, i) in website_data.offers" :key="i"
            style="height: auto;"
            class="d-flex flex-column"
          >
            <v-img :src="offers_image + '?d=333x336&location=center'" class="pba-offers-img">
              <template #placeholder><progress-circular-primary /></template>
            </v-img>
            <div class="d-flex flex-column flex-grow-1 pba-offers-info pba-surface text-center">
              <div
                class="pba-text-card-headline mb-3 pba-primary--text"
                v-html="offers_title"
              />
              <div
                class="pba-text-card-body-2 mb-4"
                v-html="offers_preview"
              />
              <div class="d-flex justify-space-between flex-grow-1 align-end">
                <v-btn
                  elevation="0" tile outlined color="pba-primary"
                  class="pba-card-btn text-uppercase"
                  :class="!website_data.profile.hotel_simplebooking && 'flex-grow-1'"
                  @click="
                    dialogs['offer_' + i] = true
                    gtagViewEvent(`Offers Detail '${offers_title}'`)
                  "
                  v-html="'VIEW DETAILS'"
                />
                <v-btn
                  v-if="offers_link || website_data.profile.hotel_simplebooking"
                  elevation="0" tile color="pba-primary"
                  class="pba-card-btn pba-secondary--text text-uppercase"
                  :href="offers_link || toQueryUrl(
                    website_data.profile.hotel_simplebooking,
                    promo_code ? {...utm_data, coupon: promo_code } : utm_data
                  )"
                  target="_blank" rel="noopener nofollow"
                  @click="gtagClickEvent('Offers', `'${offers_title}' Book Now`)"
                  v-html="label_data.BOOK_NOW"
                />
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div v-if="swipers.offers && website_data.offers.length > 1" class="pba-swiper-buttons-mobile pba-swiper-buttons-mobile-offers align-center justify-space-between">
          <v-btn
            tile color="pba-secondary" elevation="0"
            style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
            :disabled="swipers.offers.isBeginning"
            @click="swipers.offers.slidePrev()"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            tile color="white" elevation="0"
            style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
            :disabled="swipers.offers.isEnd"
            @click="swipers.offers.slideNext()"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-container>

    <div id="section-photos" class="pba-photos pba-section px-0 overflow-hidden">
      <v-container>
        <span
          v-if="label_data.MENU_PHOTOS"
          class="pba-text-section-name pba-secondary text-uppercase"
          v-html="label_data.MENU_PHOTOS"
        />
        <div
          class="pba-text-section-headline pba-primary--text mb-4 mb-lg-8 align-end"
          v-html="website_data.profile.headline_gallery"
        />
      </v-container>

      <div class="pos-relative">
        <swiper
          pagination
          :space-between="20"
          :breakpoints="{ 1264: { slidesPerView: Math.min(4, website_data.gallery.length), spaceBetween: 0 } }"
          class="overflow-visible swiper-dialog"
          @swiper="$set(swipers, 'gallery', $event)"
        >
          <swiper-slide v-for="({ gallery_image }, i) in website_data.gallery" :key="i">
            <v-img
              class="pba-photos-img cursor-pointer"
              :src="gallery_image + '?d=476x360&location=center'"
              @click="viewDialogImage('gallery', i)"
            >
              <template #placeholder><progress-circular-primary /></template>
            </v-img>
          </swiper-slide>
        </swiper>
        <div v-if="swipers.gallery && website_data.gallery.length > 4" class="pba-swiper-buttons-inside align-center justify-center d-none d-lg-flex">
          <v-container class="d-flex justify-space-between">
            <v-btn
              tile color="pba-secondary"
              style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
              :disabled="swipers.gallery.isBeginning"
              @click="swipers.gallery.slidePrev()"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn
              tile color="white"
              style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
              :disabled="swipers.gallery.isEnd"
              @click="swipers.gallery.slideNext()"
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-container>
        </div>
      </div>
    </div>

    <v-container v-if="website_data.press && website_data.press.length" id="section-news" class="pba-section">
      <div class="d-flex mb-4 mb-lg-8 align-end">
        <div>
          <span
            v-if="label_data.MENU_NEWS"
            class="pba-text-section-name pba-secondary text-uppercase"
            v-html="label_data.MENU_NEWS"
          />
          <div
            class="pba-text-section-headline pba-primary--text"
            v-html="website_data.profile.headline_news"
          />
        </div>
        <v-spacer />
        <div v-if="swipers.news && website_data.press.length > 2" class="pba-swiper-buttons">
          <v-btn
            color="pba-secondary" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
            :disabled="swipers.news.isBeginning"
            @click="swipers.news.slidePrev()"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            color="white" elevation="0" class="pba-btn-slide pba-primary--text rounded-0"
            :disabled="swipers.news.isEnd"
            @click="swipers.news.slideNext()"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="pos-relative">
        <swiper
          :space-between="16"
          :breakpoints="{ 1264: { slidesPerView: 2 } }"
          :allow-touch-move="website_data.press.length > (isMobile ? 1 : 2)"
          @swiper="$set(swipers, 'news', $event)"
        >
          <swiper-slide
            v-for="({ press_title, press_preview, published_date, press_image }, i) in website_data.press" :key="i"
            class="d-flex flex-column"
            style="height: auto;"
          >
            <v-img :src="press_image + '?d=560x320&location=center'" class="pba-news-img">
              <template #placeholder><progress-circular-primary /></template>
            </v-img>
            <div class="d-flex flex-column flex-grow-1">
              <div
                class="pba-news-headline pba-text-news-headline pba-primary--text"
                v-html="press_title"
              />
              <div
                class="pba-news-date pba-text-news-date"
                v-html="new Date(published_date).toLocaleDateString('en-us', {
                  weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
                })"
              />
              <v-spacer />
              <div
                class="pba-news-body pba-text-news-body"
                v-html="press_preview"
              />
              <div>
                <div class="d-flex align-center cursor-pointer" @click="$router.push({ name: 'News', query: { go: 'news-' + i } })">
                  <div class="pba-text-news-readmore pba-primary--text">
                    Read More
                  </div>
                  <v-icon color="pba-secondary" class="mx-2">
                    mdi-arrow-right
                  </v-icon>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <div v-if="swipers.news && website_data.press.length > 1" class="pba-swiper-buttons-mobile pba-swiper-buttons-mobile-news align-center justify-space-between">
          <v-btn
            tile color="pba-secondary" elevation="0"
            style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
            :disabled="swipers.news.isBeginning"
            @click="swipers.news.slidePrev()"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            tile color="white" elevation="0"
            style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
            :disabled="swipers.news.isEnd"
            @click="swipers.news.slideNext()"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-container>

    <!-- OFFERS SPLASH -->
    <v-dialog
      v-if="website_data.offers && website_data.offers.length"
      :value="isSplashOffers"
      overlay-color="black"
      overlay-opacity="0.8"
      content-class="elevation-0 pba-dialog overflow-visible"
      class="d-flex justify-center"
      @input="v => v || setSplashOffers()"
    >
      <swiper
        pagination
        class="overflow-visible swiper-dialog pos-relative"
        :allow-touch-move="website_data.offers.length > 1"
        @swiper="$set(dialogSwipers, 'splashOffers', $event)"
      >
        <swiper-slide
          v-for="({ offers_image, offers_link, promo_code }, j) in website_data.offers" :key="j"
        >
          <a
            v-if="offers_link || website_data.profile.hotel_simplebooking"
            :href="offers_link || toQueryUrl(
              website_data.profile.hotel_simplebooking,
              promo_code ? {...utm_data, coupon: promo_code } : utm_data
            )"
            target="_blank" rel="noopener nofollow"
          >
            <v-img
              contain :src="offers_image"
              class="pba-dialog-img"
            >
              <template #placeholder>
                <div class="d-flex fill-height justify-center align-center">
                  <v-progress-circular :size="64" indeterminate color="pba-secondary" />
                </div>
              </template>
            </v-img>
          </a>
          <v-img
            v-else
            contain :src="offers_image"
            class="pba-dialog-img"
          >
            <template #placeholder>
              <div class="d-flex fill-height justify-center align-center">
                <v-progress-circular :size="64" indeterminate color="pba-secondary" />
              </div>
            </template>
          </v-img>
        </swiper-slide>
        <div v-if="dialogSwipers.splashOffers" class="pba-swiper-buttons-inside">
          <v-container class="d-flex flex-column">
            <div class="d-flex justify-end">
              <v-btn
                id="splashOffers-close"
                tile color="white"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                @click="setSplashOffers"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-spacer />
            <div v-if="dialogSwipers.splashOffers.slides.length > 1" class="d-none d-lg-flex justify-space-between">
              <v-btn
                id="splashOffers-previous"
                tile color="pba-secondary"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                :disabled="dialogSwipers.splashOffers.isBeginning"
                @click="dialogSwipers.splashOffers.slidePrev()"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                id="splashOffers-next"
                tile color="white"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                :disabled="dialogSwipers.splashOffers.isEnd"
                @click="dialogSwipers.splashOffers.slideNext()"
              >
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
            <v-spacer />
          </v-container>
        </div>
      </swiper>
    </v-dialog>

    <!-- OFFERS DIALOG -->
    <v-dialog
      v-for="({ offers_title, offers_image, offers_desc, offers_link, promo_code }, i) in website_data.offers" :key="'offer_' + i"
      v-model="dialogs['offer_' + i]"
      overlay-color="black"
      overlay-opacity="0.8"
      content-class="elevation-0 rounded-0"
    >
      <v-container class="pos-relative pa-0">
        <v-btn
          class="pos-absolute pba-btn-slide pba-primary--text"
          style="right: 0; z-index: 1;"
          elevation="0" tile color="white"
          @click="dialogs['offer_' + i] = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div
          class="pba-dialog-offers d-flex flex-column flex-lg-row white py-10 px-6 px-lg-8"
        >
          <v-img :src="offers_image + '?d=432x432&location=center'" class="pba-offers-dialog-img me-lg-8">
            <template #placeholder><progress-circular-primary /></template>
          </v-img>
          <div class="d-flex flex-column flex-grow-1">
            <div class="pba-text-offers-dialog-headline pba-primary--text my-6" v-html="offers_title" />
            <div class="overflow-auto scrollbar-dark pba-text-section-body me-lg-8 mb-lg-8 pe-lg-4" v-html="offers_desc" />
            <v-btn
              v-if="offers_link || website_data.profile.hotel_simplebooking"
              elevation="0" tile color="pba-primary"
              class="pba-btn-book flex-grow-1 flex-lg-grow-0 text-uppercase pba-secondary--text"
              :href="offers_link || toQueryUrl(
                website_data.profile.hotel_simplebooking,
                promo_code ? {...utm_data, coupon: promo_code } : utm_data
              )"
              target="_blank" rel="noopener nofollow"
              v-html="label_data.BOOK_NOW"
            />
          </div>
        </div>
      </v-container>
    </v-dialog>

    <!-- ROOM TYPES DIALOGS -->
    <v-dialog
      v-for="({ room_id, room_image, room_title }, i) in website_data.rooms" :key="'room_' + i"
      v-model="dialogs[room_id]"
      overlay-color="black"
      overlay-opacity="0.8"
      content-class="elevation-0 pba-dialog overflow-visible"
      class="d-flex justify-center"
    >
      <swiper
        pagination
        class="overflow-visible swiper-dialog pos-relative"
        :allow-touch-move="room_image.length > 1"
        @swiper="$set(dialogSwipers, room_id, $event)"
        @slideChange="gtagClickEvent('Rooms', `'${room_title}' Swipe Gallery`)"
      >
        <swiper-slide v-for="({ image_url }, j) in room_image" :key="j">
          <v-img contain :src="image_url" class="pba-dialog-img">
            <template #placeholder>
              <div class="d-flex fill-height justify-center align-center">
                <v-progress-circular :size="64" indeterminate color="pba-secondary" />
              </div>
            </template>
          </v-img>
        </swiper-slide>
        <div v-if="dialogSwipers[room_id]" class="pba-swiper-buttons-inside">
          <v-container class="d-flex flex-column">
            <div class="d-flex justify-end">
              <v-btn
                tile color="white"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                @click="dialogs[room_id] = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-spacer />
            <div v-if="dialogSwipers[room_id].slides.length > 1" class="d-none d-lg-flex justify-space-between">
              <v-btn
                tile color="pba-secondary"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                :disabled="dialogSwipers[room_id].isBeginning"
                @click="dialogSwipers[room_id].slidePrev()"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                tile color="white"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                :disabled="dialogSwipers[room_id].isEnd"
                @click="dialogSwipers[room_id].slideNext()"
              >
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
            <v-spacer />
          </v-container>
        </div>
      </swiper>
    </v-dialog>

    <!-- ABOUT DIALOG -->
    <v-dialog
      v-model="dialogs.about"
      overlay-color="black"
      overlay-opacity="0.8"
      content-class="elevation-0 pba-dialog overflow-visible"
      class="d-flex justify-center"
    >
      <swiper
        pagination
        class="overflow-visible swiper-dialog pos-relative"
        :allow-touch-move="website_data.thumbnail_about.length > 1"
        @swiper="$set(dialogSwipers, 'about', $event)"
      >
        <swiper-slide v-for="({ gallery_image }, i) in website_data.thumbnail_about" :key="i">
          <v-img contain :src="gallery_image" class="pba-dialog-img">
            <template #placeholder>
              <div class="d-flex fill-height justify-center align-center">
                <v-progress-circular :size="64" indeterminate color="pba-secondary" />
              </div>
            </template>
          </v-img>
        </swiper-slide>
        <div v-if="dialogSwipers.about" class="pba-swiper-buttons-inside">
          <v-container class="d-flex flex-column">
            <div class="d-flex justify-end">
              <v-btn
                tile color="white"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                @click="dialogs.about = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-spacer />
            <div v-if="dialogSwipers.about.slides.length > 1" class="d-none d-lg-flex justify-space-between">
              <v-btn
                tile color="pba-secondary"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                :disabled="dialogSwipers.about.isBeginning"
                @click="dialogSwipers.about.slidePrev()"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                tile color="white"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                :disabled="dialogSwipers.about.isEnd"
                @click="dialogSwipers.about.slideNext()"
              >
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
            <v-spacer />
          </v-container>
        </div>
      </swiper>
    </v-dialog>

    <!-- GALLERY DIALOG -->
    <v-dialog
      v-model="dialogs.gallery"
      overlay-color="black"
      overlay-opacity="0.8"
      content-class="elevation-0 pba-dialog overflow-visible"
      class="d-flex justify-center"
    >
      <swiper
        pagination
        class="overflow-visible swiper-dialog pos-relative"
        :allow-touch-move="website_data.gallery.length > 1"
        @swiper="$set(dialogSwipers, 'gallery', $event)"
      >
        <swiper-slide v-for="({ gallery_image }, i) in website_data.gallery" :key="i">
          <v-img contain :src="gallery_image" class="pba-dialog-img">
            <template #placeholder>
              <div class="d-flex fill-height justify-center align-center">
                <v-progress-circular :size="64" indeterminate color="pba-secondary" />
              </div>
            </template>
          </v-img>
        </swiper-slide>
        <div v-if="dialogSwipers.gallery" class="pba-swiper-buttons-inside">
          <v-container class="d-flex flex-column">
            <div class="d-flex justify-end">
              <v-btn
                tile color="white"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                @click="dialogs.gallery = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-spacer />
            <div v-if="dialogSwipers.gallery.slides.length > 1" class="d-none d-lg-flex justify-space-between">
              <v-btn
                tile color="pba-secondary"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                :disabled="dialogSwipers.gallery.isBeginning"
                @click="dialogSwipers.gallery.slidePrev()"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                tile color="white"
                style="z-index: 1" class="pba-btn-slide pba-primary--text mx-n2"
                :disabled="dialogSwipers.gallery.isEnd"
                @click="dialogSwipers.gallery.slideNext()"
              >
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
            <v-spacer />
          </v-container>
        </div>
      </swiper>
    </v-dialog>
  </div>
</template>

<script>
  // Extensions
  import View from '@/views/View'

  export default {
    name: 'Home',

    extends: View,

    props: {
      id: {
        type: String,
        default: 'home',
      },
    },

    data () {
      return {
        swipers: {},
        dialogSwipers: {},
        roomsSwipers: {},

        dialogs: {
          about: false,
          gallery: false,
        },

        booking: {
          periodModel: false,
          periodRange: [null, null],
          guests: 1,
        },
        bookingValid: null,

        rules: {
          required: [value => !!value || 'Required.'],
        },
      }
    },

    computed: {
      bookingLink () {
        // https://simplebooking.astonhotelsinternational.com/ibe/hotelbooking/search?hid=8268&lang=en&guests=A,A&in=2022-10-07&out=2022-10-08
        const { guests } = this.booking
        const [start, end] = [...this.booking.periodRange].sort()
        // Check all fields
        return guests > 0 && start && end
          ? this.toQueryUrl(this.website_data.profile.hotel_simplebooking, {
            ...this.utm_data,
            guests: Array(this.booking.guests).fill('A'),
            in: start,
            out: end
          })
          : null
      },
    },

    created () {
      this.website_data.rooms.forEach(({ room_id }) => {
        this.$set(this.dialogs, room_id, false)
      })
      this.website_data.offers && this.website_data.offers?.length && this.website_data.offers.forEach((_, i) => {
        this.$set(this.dialogs, 'offer_' + i, false)
      })
    },

    mounted () {
      const { go } = this.$route.query
      this.$router.replace({
        ...this.$router.currentRoute,
        query: { go: undefined },
      })
      go && document.getElementById(go) && this.$vuetify.goTo('#' + go, { duration: 0, appOffset: false, offset: document.getElementById('appbar').offsetHeight })
    },

    methods: {
      viewDialogImage (dialog, index) {
        this.dialogs[dialog] = true
        // Wait for swiper to be rendered before calling slideTo
        this.$nextTick(() => {
          this.dialogSwipers[dialog].slideTo(index)
        })
      },

      formatDate (date) {
        if (date) {
          date = new Date(date)
          return [date.getDate(), date.getMonth() + 1, date.getFullYear()].join('/')
        } else return ''
      },
    },
  }
</script>
